// extracted by mini-css-extract-plugin
module.exports = {"slide":"InvoiceInfoForShow_slide_1LG8y","slide-reverse":"InvoiceInfoForShow_slide-reverse_2sbz8","invoice":"InvoiceInfoForShow_invoice_jov7j"};